module.exports = __webpack_public_path__ + "img/arrow_lime.d83c934d.svg";